import { ForgottenPasswordStore } from "./types";
import { useMutation, useQuery } from "@common/utils/use-query";

export const forgottenPasswordStore: ForgottenPasswordStore = {
  useSendResetEmail() {
    return useMutation({
      url: "/forgotten_password",
      method: "POST",
    });
  },

  useInvalidateToken(token: string) {
    return useQuery(
      {
        url: `/forgotten_password/${token}`,
      },
      { enabled: !!token },
    );
  },

  useResetPassword(token: string) {
    return useMutation({
      url: `/forgotten_password/${token}`,
      method: "POST",
    });
  },
};
